import {
	useEffect,
} from 'react';
import './App.scss';
import {
	Toaster,
} from 'react-hot-toast';
import {
	BrowserRouter,
	Routes,
} from 'react-router-dom';
import {
	ContentViews,
	getRoutes,
} from 'utils/navigation/Navigation';
import Authenticate  from 'components/authenticate';
import Navigation from 'pages/navigation/Navigation';
import {
	useSyncQueuedApiCalls,
} from 'hooks';
import {
	initLogRocket, setSessionToLogRocket,
} from 'utils/logrocket';
import {
	showToastIfNotInstalled,
} from 'utils/install/utils';

const App = () => {
	useSyncQueuedApiCalls();

	useEffect(() => {
		initLogRocket();
		setSessionToLogRocket();
		showToastIfNotInstalled();
	}, []);

	return (
		<div className="app">
			<BrowserRouter>
				<div className="app-content">
					<Authenticate login={ContentViews.LOGIN.element}>
						<div>
							<Navigation />
							<Routes>
								{getRoutes()}
							</Routes>
						</div>
					</Authenticate>
				</div>
			</BrowserRouter>
			<Toaster />
		</div>
	);
};

export default App;
